import { Div } from '../../../base/components/native/div'
import { H3 } from '../../../base/components/native/h'
import services from '../../../services'
import { DInput } from '../../shared/d-input'
import { UserItem } from './user-item'

export const SearchUsers = () => {

    const base = Div()
    const search = DInput('جستجوی کاربران', { placeholderAlign: 'left', direction: 'ltr' })
    const list = Div()
    base.append(search, list)

    base.on('mounted', async () => {
        const { data } = await services.users.getAll() as { data: any[] }
        data.forEach((cashback: any) => {
            const item = UserItem(cashback)
            item.el.onclick = () => base.emit('user-selected', cashback)
            list.append(item)
        })
        search.on('input', (value: any) => {
            list.empty()
            data.forEach((cashback: any) => {
                if (cashback?.phone?.includes(value.toLowerCase()) || cashback?.name?.includes(value.toLowerCase()) || cashback?.email?.includes(value.toLowerCase())) {
                    const item = UserItem(cashback)
                    item.el.onclick = () => base.emit('user-selected', cashback)
                    list.append(item)
                }
            })
        })
    })

    search.cssClass({
        margin: '20px 0 20px 0',
    })
    list.cssClass({
        overflow: 'scroll',
        height: 'calc(100vh - 200px)'
    })
    base.cssClass({
        width: '25%',
        direction: 'ltr',
        borderRight: '1px solid #ccc',
        padding: '0 20px 100px 0px',
    })

    return base
}